import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard, ShoppingBag, Package, Tag, Users,
  CreditCard, LogOut, Zap, ChevronRight
} from 'lucide-react';

const NAV = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/bookings', label: 'Bookings', icon: ShoppingBag },
  { to: '/services', label: 'Services', icon: Package },
  { to: '/categories', label: 'Categories', icon: Tag },
  { to: '/customers', label: 'Customers', icon: Users },
  { to: '/transactions', label: 'Transactions', icon: CreditCard },
];

export default function Sidebar() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div className="w-60 flex-shrink-0 bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 min-h-screen flex flex-col text-white shadow-2xl">
      {/* Logo */}
      <div className="p-6 border-b border-white/10">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center shadow-lg">
            <Zap size={18} strokeWidth={2.5} className="text-white" />
          </div>
          <div>
            <div className="font-black text-base leading-none">
              <span className="text-white">Urban</span>
              <span className="text-orange-400">Pro</span>
            </div>
            <div className="text-xs text-slate-400 font-medium mt-0.5">Admin Panel</div>
          </div>
        </div>
      </div>

      {/* Admin Info */}
      <div className="px-4 py-4 border-b border-white/10">
        <div className="flex items-center gap-3 bg-white/5 rounded-xl p-3">
          <img src={admin?.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(admin?.full_name || 'Admin')}&background=f3700e&color=fff`}
            alt="Admin" className="w-9 h-9 rounded-lg object-cover" />
          <div className="min-w-0">
            <p className="text-sm font-semibold truncate">{admin?.first_name} {admin?.last_name}</p>
            <p className="text-xs text-orange-400 font-medium">Super Admin</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-3 space-y-1">
        {NAV.map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to} end={to === '/'}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all group ${
                isActive ? 'bg-orange-500 text-white shadow-lg shadow-orange-500/20' : 'text-slate-300 hover:bg-white/8 hover:text-white'
              }`
            }>
            <Icon size={17} />
            <span className="flex-1">{label}</span>
            <ChevronRight size={14} className="opacity-0 group-hover:opacity-50 transition-opacity" />
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-white/10">
        <button onClick={handleLogout}
          className="flex items-center gap-3 w-full px-3 py-2.5 rounded-xl text-sm font-medium text-slate-400 hover:text-white hover:bg-red-500/20 transition-all">
          <LogOut size={17} />
          Sign Out
        </button>
      </div>
    </div>
  );
}
